export default {
  BusinessPurchaseReturnComDetail: {
    purchaseText: '采购退货出库',
    statusText: '单状态',
    operationLog: '操作日志',
    statusMeaning: '退货出库状态',
    planQty: '单据数量',
    alreadyQty: '已出库',
    waitQty: '未出库',
    informationText: '单基本信息',
    stockoutCode: '退货出库通知单号',
    resultCode: '退货出库结果单号',
    typeMeaning: '退货出库类型',
    supplierName: '供应商',
    warehouseName: '退货仓库',
    purchaseCode: '采购单号',
    auditDate: '审核时间',
    stockoutDate: '出库时间',
    logisticsBusinessName: '物流公司',
    logisticsNo: '物流单号',
    recipientName: '收件人',
    recipientPhone: '手机',
    recipientAddress: '收货地址',
    notify: '通知',
    result: '结果',
    one: '单',
    log: '日志',

    table: {
      title: '采购退货商品信息',
      spuPic: '商品图片',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '单据数量',
      alreadyQty: '实际入库数量',
      waitQty: '未入库数量',
      taxUnitPrice: '含税下单价',
      taxRate: '税率',
      taxPrice: '含税金额',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码'
    }

  },
  BusinessPurchaseReturnComPage: {
    header: {
      queryCode: '退货出库单号',
      codeText: '通知单号/结果单号',
      supplier: '供应商',
      supplierText: '供应商编码/供应商名称',
      type: '退货出库类型',
      warehouseCode: '退货仓库',
      status: '退货出库状态',
      purchaseCode: '采购单号',
      spuCode: '商品编码',
      skuCode: 'SKU编码',
      startData: '开始日期',
      endData: '结束日期',
      reviewTime: '审核时间',
      deliveryTime: '出库时间',
      logisticsBusinessName: '物流公司',
      logisticsNo: '物流单号',
    },

    review: '审核',
    antiAudit: '反审核',
    returnWarehouse: '退货出库',
    export: '导出',
    errorText: '存在状态不正确的单据，无法执行当前操作',
    msgError1: '只有待审核单据可以操作编辑',
    msgError2: '请选择待出库或待通知WMS单据操作',
    msgBox1: '是否',
    msgBox2: '所选单据',
    msgBox3: '是否取消所选单据',
    msgBox4: '是否确认退货出库？',
    downName1: '采购退货出库通知单导出',
    downName2: '采购退货出库结果单导出',

    table: {
      statusMeaning: '退货出库状态',
      typeMeaning: '退货出库类型',
      warehouseName: '退货仓库',
      supplierCode: '供应商编码',
      supplierName: '供应商名称',
      purchaseCode: '采购单号',
      logisticsBusinessName: '物流公司',
      logisticsNo: '物流单号',
      planQty: '单据数量',
      alreadyQty: '已发货数',
      amount: '总金额',
      recipientName: '收货人',
      recipientPhone: '收货电话',
      recipientAddress: '收货地址',
      auditDate: '审核时间',
      auditName: '审核人',
      stockoutDate: '出库时间',
      sourceMeaning: '来源',
      code: '退货出库结果单号',
      stockoutCode: '退货出库通知单号',
    }
  },
};
